import { render, staticRenderFns } from "./QNA.List.vue?vue&type=template&id=45bb17f8&"
import script from "./QNA.List.vue?vue&type=script&lang=js&"
export * from "./QNA.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports